import { useContext } from "react";
import { CollapseDrawerContext } from "../contexts/drawer.context";

const useCollapseDrawer = () => useContext(CollapseDrawerContext);

export default useCollapseDrawer;